import { Theme } from '@mui/material';

import { getBrandTokens } from '../../theme/getBrandTokens';
import { tokenVar } from '../../theme/brandCssVar';

export const styles = (theme: Theme) => {
  const tokens = getBrandTokens(theme);

  return {
    buttonStyles: {
      padding: `${theme.custom.padding['0_44']} ${theme.custom.padding.mediumX}`,
      textTransform: 'capitalize',
      fontSize: theme.typography.textSize['0_875'],
      fontWeight: theme.typography.fontWeight.medium,
      color: tokenVar(tokens, 'buttonSecondaryText'),
    },
    disabledButton: {
      background: theme.palette.background.sixteenary,
      '&:hover': {
        background: theme.palette.background.sixteenary,
      },
    },
    greenBorderStyles: {
      border: '1px solid',
      borderColor: tokenVar(tokens, 'buttonSecondaryBorder'),
      padding: `${theme.custom.padding.smallMedium} ${theme.custom.padding.medium}`,
      borderRadius: theme.custom.borderRadius.medium,
      color: tokenVar(tokens, 'buttonSecondaryText'),
    },
    noBackgroundStyles: {
      backgroundColor: 'transparent',
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    outlinedBtnStyles: {
      border: '1px solid',
      borderColor: 'background.default',
      borderRadius: theme.custom.borderRadius['2'],
      color: 'background.default',
    },
    yellowButtonStyles: {
      background: tokenVar(tokens, 'buttonPrimaryGradient'),
      padding: `${theme.custom.padding.smallMedium} ${theme.custom.padding.medium}`,
      color: tokenVar(tokens, 'buttonPrimaryText'),
      borderRadius: theme.custom.borderRadius.medium,
      '&:hover': {
        background: tokenVar(tokens, 'buttonPrimaryHoverGradient'),
      },
    },
    btnLoaderStyles: {
      marginLeft: theme.custom.margin.xSmall,
      color: tokenVar(tokens, 'accentColor'),
    },
  };
};
